"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedLimitedPartnerCommitmentDataSchema = exports.LimitedPartnerPortfolioSummarySchema = exports.PortfolioOverviewGraphDataSchema = exports.LimitedPartnerCapitalTrendDataSchema = exports.LimitedPartnerCommitmentDetailSchema = exports.LimitedPartnerCommitmentSchema = exports.LimitedPartnerTapeOptionalStaticProps = exports.LimitedPartnerTapeRequiredStaticPropsIterable = exports.requiredGeneratedLoanTapeBaseFields = exports.LimitedPartnerNotFoundError = exports.LimitedPartnerFacilityType = void 0;
const zod_1 = require("zod");
const UtilTypes = __importStar(require("./Utils"));
exports.LimitedPartnerFacilityType = 'capitalCallLine';
exports.LimitedPartnerNotFoundError = 'LimitedPartnersNotFoundError';
// For fund finance pipeline we will require that the following fields are present in the
// generated loan tape. some are required from the raw tape, and some are appended by
// createLimitedPartnersTape task.
// Besides these some dynamic properties will be added to the tape
// based on the node configuration.
exports.requiredGeneratedLoanTapeBaseFields = [
    //
    // required fields from the raw tape
    //
    {
        fieldName: 'committed_capital',
        fieldType: 'float',
    },
    {
        fieldName: 'called_capital',
        fieldType: 'float',
    },
    {
        fieldName: 'uncalled_capital',
        fieldType: 'float',
    },
    {
        fieldName: 'recallable_capital',
        fieldType: 'float',
    },
    // normalized required field appended by createLimitedPartnersTape task
    {
        fieldName: 'limited_partner_alias',
        fieldType: 'string',
    },
    //
    // props appended by createLimitedPartnersTape task from limited_partners table
    // for the matching limited partner.
    //
    {
        fieldName: 'limited_partner_id',
        fieldType: 'optionalString',
    },
    {
        fieldName: 'limited_partner_name',
        fieldType: 'optionalString',
    },
];
// required properties regarding LP from a receivable (commitment) tape.
exports.LimitedPartnerTapeRequiredStaticPropsIterable = [
    'committed_capital',
    'called_capital',
    'uncalled_capital',
    // besides above static props
    // tape will also have dynamic properties
    // specified by the node configuration
    //
    // externalReceivableIdField,
    // limitedPartnerNameAliasField,
];
// optional properties regarding LP from a receivable (commitment) tape.
exports.LimitedPartnerTapeOptionalStaticProps = [
    { fieldName: 'recallable_capital', fieldType: 'float' },
];
exports.LimitedPartnerCommitmentSchema = zod_1.z.object({
    limitedPartnerAlias: zod_1.z.string(),
    finleyReceivableId: zod_1.z.string(),
    limitedPartnerId: zod_1.z.string().nullable(),
    limitedPartnerName: zod_1.z.string().nullable(),
    creditFacilityId: zod_1.z.string(),
    creditFacilityName: zod_1.z.string(),
    borrowerSlug: zod_1.z.string(),
    borrowerName: zod_1.z.string(),
    committedCapital: zod_1.z.number(),
    uncalledCapital: zod_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
});
exports.LimitedPartnerCommitmentDetailSchema = zod_1.z.object({
    limitedPartnerAlias: zod_1.z.string(),
    finleyReceivableId: zod_1.z.string(),
    limitedPartnerId: zod_1.z.string(),
    limitedPartnerName: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    creditFacilityName: zod_1.z.string(),
    borrowerSlug: zod_1.z.string(),
    borrowerName: zod_1.z.string(),
    committedCapital: zod_1.z.number(),
    uncalledCapital: zod_1.z.number(),
    recallableCapital: zod_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
    eligibleUncalledCapitalLessKickouts: zod_1.z.number(),
    netUncalledCapital: zod_1.z.number(),
    percentageOfNetUncalledCapital: zod_1.z.number(),
    mappingId: zod_1.z.string(),
    matchedByUserName: zod_1.z.string().nullable(),
    matchedByUserEmail: zod_1.z.string().nullable(),
    matchedAt: zod_1.z.string().transform((val) => new Date(val)),
});
exports.LimitedPartnerCapitalTrendDataSchema = zod_1.z.object({
    finleyReceivableId: zod_1.z.string(),
    committedCapital: zod_1.z.number(),
    uncalledCapital: zod_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
});
exports.PortfolioOverviewGraphDataSchema = zod_1.z.object({
    totalPrincipalBalance: zod_1.z.number(),
    totalUncalledCapital: zod_1.z.number(),
    totalCommittedCapital: zod_1.z.number(),
    reportingDate: UtilTypes.ZodFullDateStrStruct,
});
exports.LimitedPartnerPortfolioSummarySchema = zod_1.z.object({
    totalUncalledCapital: zod_1.z.number(),
    totalCommittedCapital: zod_1.z.number(),
    commitmentCount: zod_1.z.number().int(),
    limitedPartnerCount: zod_1.z.number().int(),
});
exports.AggregatedLimitedPartnerCommitmentDataSchema = zod_1.z.object({
    limitedPartnerName: zod_1.z.string(),
    limitedPartnerId: zod_1.z.string(),
    commitmentCount: zod_1.z.number().int(),
    totalCommittedCapital: zod_1.z.number(),
    totalRecallableCapital: zod_1.z.number(),
    percentageOfPortfolioCommittedCapital: zod_1.z.number(),
    totalUncalledCapital: zod_1.z.number(),
    percentageOfPortfolioUncalledCapital: zod_1.z.number(),
    eligibleUncalledCapital: zod_1.z.number(),
    eligibleUncalledCapitalLessKickouts: zod_1.z.number(),
    advanceRate: zod_1.z.number(),
    netUncalledCapital: zod_1.z.number(),
    percentageOfPortfolioNetUncalledCapital: zod_1.z.number(),
});
//# sourceMappingURL=LimitedPartners.js.map